import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IExportSalesOrder,
  IExportSalesOrderInitialState,
} from "./exportSalesOrderModel";
import {
  createExportSalesOrder,
  createSingleExportSalesOrder,
  deleteExportSalesOrder,
  deleteExportSalesOrderItem,
  getAllExportSalesOrder,
  getExportSalesOrderByID,
  getExportSalesOrderByPONO,
  getExportSalesOrderListByID,
  getExportSalesOrderPrint,
  getLatestPoNo,
  updateExportSalesOrder,
} from "./services/exporSalesOrder.services";

const initialState: IExportSalesOrderInitialState = {
  loading: false,
  error: "",
  formLoading: false,
  ExportSalesOrderList: [],
  ExportSalesOrderDetailsID: null,
  ExportSalesOrderItemID: null,
  ExportSalesOrderPrintDetail: {},
  ExportSalesOrderDetail: {
    po_date: new Date(),
    party_id: null,
    exp_delivery_date: "",
    item_id: null,
    alias_name: "",
    packing_weight: null,
    unit_id: null,
    packing_unit_id: null,
    packing_size: null,
    quantity_ctn: null,
    total_kg: null,
    barcode: "",
    user_id: null,
    size_c: null,
    size_b: null,
    size_m: null,
    total: null,
    sub_total: null,
  },
  ExportSalesOrderDetailByPONO: {
    id: null,
    pono: "",
    po_date: "",
    party_id: null,
    exp_delivery_date: "",
    export_sales_order_pending: [],
    export_sales_order_packing_list: [],
  },
};

const exportSalesOrderSlice = createSlice({
  name: "exportsalesorder",
  initialState,
  reducers: {
    setExportSalesOrderDetail: (state, action) => {
      state.ExportSalesOrderDetail = action.payload;
    },
    clearExportSalesOrderDetail: (state) => {
      state.ExportSalesOrderDetail = initialState.ExportSalesOrderDetail;
    },
    clearExportSalesOrderDetailByPONO: (state) => {
      state.ExportSalesOrderDetailByPONO =
        initialState.ExportSalesOrderDetailByPONO;
    },
    setExportSalesOrderDetailsID: (state, action) => {
      state.ExportSalesOrderDetailsID = action.payload;
    },
    setExportSalesOrderItemID: (state, action) => {
      state.ExportSalesOrderItemID = action.payload;
    },
    clearExportSalesOrderItemID: (state) => {
      state.ExportSalesOrderItemID = initialState.ExportSalesOrderItemID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllExportSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllExportSalesOrder.fulfilled,
      (state, action: PayloadAction<IExportSalesOrder[]>) => {
        state.loading = false;
        state.ExportSalesOrderList = action.payload || [];
      }
    );
    builder.addCase(getAllExportSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ExportSalesOrderList = [];
    });

    builder.addCase(createExportSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createExportSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createExportSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getLatestPoNo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getLatestPoNo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getLatestPoNo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createSingleExportSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createSingleExportSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createSingleExportSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateExportSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateExportSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateExportSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteExportSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteExportSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteExportSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteExportSalesOrderItem.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteExportSalesOrderItem.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteExportSalesOrderItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getExportSalesOrderByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getExportSalesOrderByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ExportSalesOrderDetail = action.payload;
    });
    builder.addCase(getExportSalesOrderByID.rejected, (state, action) => {
      state.loading = false;
      state.ExportSalesOrderDetail = initialState.ExportSalesOrderDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getExportSalesOrderListByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getExportSalesOrderListByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ExportSalesOrderDetail = {
          ...state.ExportSalesOrderDetail,
          export_sales_order_groupwise:
            action.payload?.export_sales_order_groupwise || [],
        };
      }
    );
    builder.addCase(getExportSalesOrderListByID.rejected, (state, action) => {
      state.loading = false;
      state.ExportSalesOrderDetail = initialState.ExportSalesOrderDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getExportSalesOrderByPONO.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getExportSalesOrderByPONO.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ExportSalesOrderDetailByPONO = action.payload;
      }
    );
    builder.addCase(getExportSalesOrderByPONO.rejected, (state, action) => {
      state.loading = false;
      state.ExportSalesOrderDetailByPONO =
        initialState.ExportSalesOrderDetailByPONO;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getExportSalesOrderPrint.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getExportSalesOrderPrint.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ExportSalesOrderPrintDetail = action.payload;
      }
    );
    builder.addCase(getExportSalesOrderPrint.rejected, (state, action) => {
      state.loading = false;
      state.ExportSalesOrderPrintDetail =
        initialState.ExportSalesOrderPrintDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  setExportSalesOrderDetail,
  clearExportSalesOrderDetail,
  setExportSalesOrderDetailsID,
  clearExportSalesOrderDetailByPONO,
  setExportSalesOrderItemID,
  clearExportSalesOrderItemID,
} = exportSalesOrderSlice.actions;
export default exportSalesOrderSlice.reducer;
